<section class="section-pd customAIBanner">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-11 col-lg-12">
                <div class="customAIContent">
                    <h2>為甚麼選擇我們?</h2>
                    <h1>因為我們幫助您打造並擁有自己的 AI</h1>
                    <p class="mt-4">客製化 AI，不只是工具，更是您的企業資產。</p>
                    <div class="btn-group justify-content-center mt-40">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" class="white-btn">歡迎與我們聯繫！</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="custom-shape">
        <img src="/assets/images/custom-ai/custom-ai-banner.png" width="1833" height="611" alt="custom ai" />
    </div>
</section>

<section class="section-pd pb-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>將 AI 轉化為您的策略資產</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>在 Trinka AI，我們相信 AI 不應只是另一項服務，而應該成為企業核心智慧財產的一部分，推動業務成果，並帶來長期競爭優勢。</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-11">
                <div class="media stm-media mt-4">
                    <div class="media-left">
                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 10C0.5 4.47715 4.97715 0 10.5 0H32.5V22C32.5 27.5228 28.0228 32 22.5 32H10.5C4.97715 32 0.5 27.5228 0.5 22V10Z" fill="#763393"/>
                            <rect x="2.97363" y="1.20117" width="27.5977" height="27.5977" rx="13.7988" fill="white"/>
                            <path d="M16.7725 28.7988C24.3933 28.7988 30.5713 22.6209 30.5713 15C30.5713 7.37911 24.3933 1.20117 16.7725 1.20117C9.15158 1.20117 2.97363 7.37911 2.97363 15C2.97363 22.6209 9.15158 28.7988 16.7725 28.7988ZM17.8286 22.3037L17.2357 19.5732C18.973 19.1886 20.5705 18.6885 20.4412 16.7484H18.3996V9.48178H24.5495V16.2734C24.5473 21.6709 20.5846 22.11 17.8286 22.3037ZM9.59006 22.3037L8.99546 19.5732C10.7328 19.1886 12.3303 18.6885 12.2009 16.7484H10.1594V9.48178H16.3092V16.2734C16.3071 21.6709 12.346 22.11 9.59006 22.3037Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <p class="mb-0">我們打造的客製化 AI 模型，不僅與您的業務需求高度契合，更完全由您擁有，讓您對其功能及未來發展擁有全面控制權。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pb-0 whyChooseUs">
    <div class="shape w-100 text-center">
        <img src="/assets/images/custom-ai/shape1.svg" width="1520" height="1575" alt="shape" class="img-fluid" />
    </div>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>為甚麼選擇我們?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>全面擁有，完全掌控 <span><img src="/assets/images/custom-ai/ownership.svg" width="65" height="65" alt="Full Ownership" /></span></h4>
                        <p>不同於許多保留模型控制權的 AI 服務，我們確保您擁有客製 AI 模型的智慧財產權，您掌控使用方式、部署地點及模型演進。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>客製化模型專家 <span><img src="/assets/images/custom-ai/expertise.svg" width="65" height="65" alt="Custom Models" /></span></h4>
                        <p>我們使用以人類反饋強化學習（RLHF）技術來微調模型，提升準確性與符合業務需求。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>安全且具擴展性 <span><img src="/assets/images/custom-ai/secure.svg" width="65" height="65" alt="Secure and Scalable" /></span></h4>
                        <p>我們優先考量安全部署，確保您的模型具備擴展能力並優化推理速度，兼顧成本效益。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>長期商業價值 <span><img src="/assets/images/custom-ai/value.svg" width="65" height="65" alt="Business Value" /></span></h4>
                        <p>擁有自己的 AI，即是為企業打造隨數據成長、隨需求擴展的寶貴資產。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="customAI_LearnMore hideCard4">
    <app-learn-more-section></app-learn-more-section>
</section>

<section class="section-pd custom-ai-gradient-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h2>想知道您的企業如何從專屬 AI 模型中受益？</h2>
                </div>
                <div class="btn-group justify-content-center mt-40">
                    <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" class="filled-btn">歡迎與我們聯繫！</button>
                </div>
            </div>
        </div>
    </div>
</section>